import APIContext from 'contexts/base/APIContext'

export default class RegionsContext extends APIContext{
  static contextName = 'regions'
}
